module.exports = __webpack_public_path__ + "b-lite-thumbnail.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/b-lite-thumbnail.jpg
// module id = 1856
// module chunks = 0